import { isEmpty } from 'lodash';
import { useInfiniteQuery } from 'react-query';
import { queryGet } from '../../../utils/queryClient';

const DEFAULT_PAGE = 30;

export default function useCommentsQuery({ postId, userProfileId, perPage }) {
  async function fetchComments({ pageParam = 1 }) {
    const queryParams = new URLSearchParams({
      per_page: perPage || DEFAULT_PAGE,
      page: pageParam
    });

    if (!isEmpty(postId)) {
      queryParams.append('post_id', postId);
    }

    if (!isEmpty(userProfileId)) {
      queryParams.append('user_profile_id', userProfileId);
    }

    const url = `/api/v1/comments?${queryParams.toString()}`;
    try {
      const comments = await queryGet(url);
      return comments;
    } catch (_error) {
      throw new Error('Error fetching paginated data.');
    }
  }

  const { data, isFetching, fetchNextPage, hasNextPage } = useInfiniteQuery(
    ['Comments', postId, userProfileId],
    fetchComments,
    {
      getNextPageParam: (lastPage, _) => lastPage?.meta?.pagination?.nextPage
    }
  );

  return {
    data,
    isFetching,
    fetchNextPage,
    hasNextPage
  };
}
